import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Lock, Zap, ShieldCheck, ArrowRight } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-32 bg-zinc-950 relative overflow-hidden" data-id="element-106">
      {/* Glow effect behind the card */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[500px] bg-teal-500/10 blur-[150px] rounded-full pointer-events-none" data-id="element-107" />

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-zinc-900 border border-zinc-700 rounded-2xl p-8 md:p-12 shadow-2xl shadow-teal-900/20 flex flex-col lg:flex-row gap-12 items-center" data-id="element-109">
          {/* Left: Image */}
          <div className="w-full lg:w-2/5 flex justify-center" data-id="element-110">
            <img src="https://cdn.magicpatterns.com/uploads/mVykxoF4mrrNZowEnNpwE3/the_IT_LSYOFF_PIVOP_MAP.png" alt="The IT Layoff Pivot Map" className="w-full max-w-sm drop-shadow-2xl" data-id="element-111" />
          </div>

          {/* Right: Content */}
          <div className="w-full lg:w-3/5 flex flex-col" data-id="element-112">
            <div className="inline-block bg-teal-500/10 text-teal-400 font-bold tracking-widest uppercase text-xs px-3 py-1 rounded-full mb-4 self-start border border-teal-500/20" data-id="element-113">
              Get Instant Access
            </div>

            <h2 className="font-display text-4xl md:text-5xl text-zinc-50 mb-6" data-id="element-114">
              THE IT LAYOFF PIVOT MAP
            </h2>

            <ul className="space-y-3 mb-8" data-id="element-115">
              {['The Outcome Asset Audit', 'The Bleeding Neck Matrix', 'The One-Page Proposal Template', 'The Stealth Outreach Scripts', 'The 3-Tier Pricing Framework'].map((item, i) => <li key={i} className="flex items-center gap-3 text-zinc-300 font-medium" data-id="element-116">
                  <CheckCircle2 className="w-5 h-5 text-teal-500 shrink-0" data-id="element-117" />
                  {item}
                </li>)}
            </ul>

            <div className="flex items-end gap-4 mb-8 pb-8 border-b border-zinc-800" data-id="element-118">
              <div className="flex flex-col" data-id="element-119">
                <span className="text-zinc-500 line-through text-xl font-medium" data-id="element-120">
                  $97.00
                </span>
                <span className="font-display text-6xl text-emerald-400 leading-none" data-id="element-121">
                  $11.33
                </span>
              </div>
              <span className="text-zinc-400 mb-2 font-medium" data-id="element-122">
                One-time payment
              </span>
            </div>

            <a href="https://mybloommind.com/cart/55685779357769:1" target="_blank" rel="noopener noreferrer" className="w-full group relative flex items-center justify-center px-8 py-6 text-xl font-bold text-zinc-950 bg-emerald-500 hover:bg-emerald-400 rounded-lg transition-all duration-200 overflow-hidden mb-6" data-id="element-123">
              <div className="absolute inset-0 w-full h-full bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-124" />
              <span className="relative flex items-center gap-2" data-id="element-125">
                GET THE PIVOT MAP NOW
                <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-126" />
              </span>
            </a>

            <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-zinc-400 font-medium" data-id="element-127">
              <span className="flex items-center gap-1.5" data-id="element-128">
                <Lock className="w-4 h-4 text-zinc-500" data-id="element-129" /> Secure Checkout
              </span>
              <span className="flex items-center gap-1.5" data-id="element-130">
                <Zap className="w-4 h-4 text-amber-500" data-id="element-131" /> Instant Delivery
              </span>
              <span className="flex items-center gap-1.5" data-id="element-132">
                <ShieldCheck className="w-4 h-4 text-teal-500" data-id="element-133" /> Digital
                Product
              </span>
            </div>

            <p className="text-center text-zinc-500 text-sm mt-6" data-id="element-134">
              Safe & Secure Digital Delivery — Start your pivot in the next 5
              minutes.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}